import { AppBar, Box, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Toolbar, Typography, useColorScheme } from "@mui/material";
import { useState } from "react";
import MenuIcon from '@mui/icons-material/Menu';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Constants } from "../../utils/constants";
import LogoWidget from "../widgets/logo_widget";
import { SuccessButton } from "..";

export default function StartHeader(props) {

  const { children, } = props;
  const { mode } = useColorScheme();

  return (
    <Box>
      <AppBar
        position="fixed"
        sx={{
          bgcolor: 'background.default',
          borderBottom: mode ? `1px solid ${Constants.Colors[mode].border}` : "none",
          backgroundImage: "none",
        }}
        style={{
          "--Paper-shadow": "none",
          "--AppBar-background": "none",
          "--AppBar-color": "none",

        }}
      >
        <Toolbar>
          <LogoWidget />
          <Stack
            direction="row"
            spacing={0.3}
            sx={{
              ml: "auto",
            }}
          >
            <SuccessButton
              text={"Try for Free"}
              size="small"
              onClick={() => {
                document.location = "/signup/FREE";
              }}
            />
          </Stack>
        </Toolbar>
      </AppBar>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: { xs: "1rem", sm: "1rem", md: "1.5rem" }, }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
}